import { render, staticRenderFns } from "./tooltip-td.vue?vue&type=template&id=2a149bf2"
import script from "./tooltip-td.vue?vue&type=script&lang=js"
export * from "./tooltip-td.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports